import { createContext } from "react";
import type { User } from "@/features/auth/model/authTypes";

interface AuthContextType {
  user: User | null;
  isAuthenticated: boolean;
  login: (user: User) => void;
  logout: () => void;
  isAuthHydrated: boolean;
}

export const AuthContext = createContext<AuthContextType | undefined>(undefined);
